import { render, staticRenderFns } from "./ConfigApprovalDetail.vue?vue&type=template&id=52f6b642&scoped=true&"
import script from "./ConfigApprovalDetail.vue?vue&type=script&lang=js&"
export * from "./ConfigApprovalDetail.vue?vue&type=script&lang=js&"
import style0 from "./ConfigApprovalDetail.vue?vue&type=style&index=0&id=52f6b642&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f6b642",
  null
  
)

export default component.exports